import { render, staticRenderFns } from "./SchemeTextItem.vue?vue&type=template&id=4b2a4908&scoped=true&"
import script from "./SchemeTextItem.vue?vue&type=script&lang=js&"
export * from "./SchemeTextItem.vue?vue&type=script&lang=js&"
import style0 from "./SchemeTextItem.vue?vue&type=style&index=0&id=4b2a4908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2a4908",
  null
  
)

export default component.exports